import '../DeepAnalysis.less';
import React from 'react';
import { CHECK_HIGH_PRIORITY_THRESHOLD, CHECK_MEDIUM_PRIORITY_THRESHOLD } from '../settings';

type Props = {
    severity: number;
};

export default function ImpactIndicator({ severity }: Props) {
    let label;

    if (severity < CHECK_MEDIUM_PRIORITY_THRESHOLD) {
        label = 'low';
    } else if (severity < CHECK_HIGH_PRIORITY_THRESHOLD) {
        label = 'medium';
    } else {
        label = 'high';
    }

    return (
        <span className={`deep-analysis-impact-indicator ${label}`}>
            <span>{label}</span>
        </span>
    );
}
